import { Component, OnInit } from '@angular/core';

@Component({
  templateUrl: './contact-us.component.html',
  styleUrls: ['./contact-us.component.scss'],
})
export class ContactUsComponent implements OnInit {
  ngOnInit(): void {}
}
